export default "__VITE_ASSET__CpeVMaz$__"